import React, { RefObject } from "react";
import { GridColDef } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ModalRef } from "@shared/components";

export const useVoucherListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  voucherModalRef: RefObject<ModalRef>,
): GridColDef[] => {
  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "name",
        headerName: translate("voucher_batch_admin.fields.name"),
        minWidth: 250,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "all_vouchers",
        headerName: translate("voucher_batch_admin.fields.all_vouchers"),
        minWidth: 120,
        headerAlign: "right",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="right"
          />
        ),
      },
      {
        field: "used_vouchers",
        headerName: translate("voucher_batch_admin.fields.used_vouchers"),
        minWidth: 120,
        headerAlign: "right",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="right"
          />
        ),
      },
      {
        field: "remaining_vouchers",
        headerName: translate("voucher_batch_admin.fields.remaining_vouchers"),
        minWidth: 120,
        headerAlign: "right",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="right"
          />
        ),
      },
      {
        field: "valid_until",
        headerName: translate("voucher_batch_admin.fields.valid_until"),
        minWidth: 120,
        renderCell: ({ value }) => (
          <TableCell.Date value={value}  />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              onClick={() => voucherModalRef.current?.open(row)}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, voucherModalRef],
  );
};
